import { render, staticRenderFns } from "./overviewexample.vue?vue&type=template&id=3d31a5c0&"
import script from "./overviewexample.vue?vue&type=script&lang=js&"
export * from "./overviewexample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports